<template>
  <tr>
    <td colspan="13" class="px-0">
      <v-simple-table>
        <tr :class="ebene > 1 ? '' : 'grey lighten-' + (1 + ebene * 2)">
          <td class="pr-4 text-left flex-grow-1" :style="'padding-left:' + ebene * 30 + 'px;'" colspan="4">
            <v-edit-dialog persistent cancel-text :return-value.sync="item.bezeichnung">
              {{ item.bezeichnung }}
              <template v-slot:input>
                <v-text-field v-model="item.bezeichnung" label="Bezeichnung eintragen" hint="Zum Bestätigen Enter drücken, mit ESC abbrechen." single-line></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td width="2px" class="px-4"><v-divider vertical></v-divider></td>
          <td width="140px" class="px-4 text-right">
            <span v-if="item.positionen.length > 0">{{ getSum(item, 'einnahmen') | money }}</span>
            <v-edit-dialog v-else persistent :return-value.sync="item.einnahmen">
              {{ item.einnahmen | money }}
              <template v-slot:input>
                <v-text-field v-model="item.einnahmen" label="Einnahmen eintragen" hint="Zum Bestätigen Enter drücken, mit ESC abbrechen." single-line></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td width="140px" class=" px-4 text-right">
            <span v-if="item.positionen.length > 0">{{ getSum(item, 'ausgaben') | money }}</span>
            <v-edit-dialog v-else persistent :return-value.sync="item.ausgaben">
              {{ item.ausgaben | money }}
              <template v-slot:input>
                <v-text-field v-model="item.ausgaben" label="Ausgaben eintragen" hint="Zum Bestätigen Enter drücken, mit ESC abbrechen." single-line></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td width="2px" class="px-4"><v-divider vertical></v-divider></td>
          <td width="140px" class=" px-4 text-right">
            <span v-if="item.positionen.length > 0">{{ getSum(item, 'istEinnahmen') | money }}</span>
            <v-edit-dialog v-else persistent :return-value.sync="item.istEinnahmen">
              {{ item.istEinnahmen | money }}
              <template v-slot:input>
                <v-text-field v-model="item.istEinnahmen" label="Ist Einnahmen eintragen" hint="Zum Bestätigen Enter drücken, mit ESC abbrechen." single-line></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td width="140px" class=" px-4 text-right">
            <span v-if="item.positionen.length > 0">{{ getSum(item, 'istAusgaben') | money }}</span>
            <v-edit-dialog v-else persistent :return-value.sync="item.istAusgaben">
              {{ item.istAusgaben | money }}
              <template v-slot:input>
                <v-text-field v-model="item.istAusgaben" label="Ist Ausgaben eintragen" hint="Zum Bestätigen Enter drücken, mit ESC abbrechen." single-line></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
          <td width="2px" class="px-4"><v-divider vertical></v-divider></td>
          <td width="140px" class=" px-4 text-right">
            <span v-if="item.istEinnahmen || item.istAusgaben">
              {{ parseFloat(item.istEinnahmen) - parseFloat(item.einnahmen) - parseFloat(item.istAusgaben) + parseFloat(item.ausgaben)  | money }}
            </span>
            
          </td>
          <td v-if="item.positionen.length > 0" width="120px" class="px-4 text-right">
            <v-btn icon @click="addGroupRow(item)"><v-icon>add</v-icon></v-btn>
            <v-btn icon v-if="item.positionen.length === 0" @click="deleteRow(item)"><v-icon>delete</v-icon></v-btn>
            <v-btn icon v-else @click.stop="item.show = !item.show"><v-icon>keyboard_arrow_down</v-icon></v-btn>
          </td>
          <td v-else width="120px" class="px-4 text-right">
            <v-btn icon @click="addGroupRow(item)"><v-icon>playlist_add</v-icon></v-btn>
            <v-btn icon @click="deleteGroupRow(item, prop)"><v-icon>delete</v-icon></v-btn>
          </td>
        </tr>
        <rowWirtschaftsplan v-if="item.show" :parent="item" :ebene="ebene + 1" :item="pos" v-for="(pos, index) in item.positionen" :key="index"/>
      </v-simple-table>
    </td>
  </tr>
</template>

<script>
  export default {
    props: ['item', 'ebene', 'parent'],
    data () {
      return {
        loading: false
      }
    },
    methods: {
      getSum (item, key) {
        let sum = 0
        if (item.positionen && item.positionen.length > 0) {
          item.positionen.forEach(pos => {
            sum += this.getSum(pos, key)
          })
        } else {
          if (key === 'istEinnahmen') {
            if ((parseInt(item.istEinnahmen) === 0 || item.istEinnahmen === '') && (parseInt(item.istAusgaben) === 0 || item.istAusgaben === '')) {
              sum += parseInt(item.einnahmen ? item.einnahmen : 0)
            }
          }
          if (key === 'istAusgaben') {
            if ((parseInt(item.istEinnahmen) === 0 || item.istEinnahmen === '') && (parseInt(item.istAusgaben) === 0 || item.istAusgaben === '')) {
              sum += parseInt(item.ausgaben ? item.ausgaben : 0)
            }
          }
          if (key === 'einnahmen' || 'ausgaben') {
            sum += parseInt(item[key] ? item[key] : 0)
          }
        }
        return sum
      },
      addGroupRow (item) {
        console.log(item)
        if (item.positionen.length === 0) {
          item.positionen.push({
            bezeichnung: item.bezeichnung,
            show: true,
            positionen: [],
            einnahmen: item.einnahmen,
            ausgaben: item.ausgaben,
            istEinnahmen: item.istEinnahmen,
            istAusgaben: item.istAusgaben
          })
        } else {
          item.positionen.push({
            bezeichnung: 'Neu',
            show: true,
            positionen: [],
            einnahmen: 0,
            ausgaben: 0,
            istEinnahmen: 0,
            istAusgaben: 0
          })
        }
      },
      deleteRow (item) {
        this.parent.positionen.splice(this.parent.positionen.indexOf(item), 1)
      },
      deleteGroupRow (item) {
        this.parent.positionen.splice(this.parent.positionen.indexOf(item), 1)
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// rowWirtschaftsplan.vue?20826bd4